import Script from 'next/script'
import { useEffect, useRef, useState } from 'react'
import s from './TamaraPromo.module.scss'
import Tamara from '@components/icons/Tamara'
import { useRouter } from 'next/router'
import { Money } from '@pylot-data/fwrdschema'
import { useStoreConfig } from '@config/hooks/useStoreConfig'

declare global {
    interface Window {
        tamaraWidgetConfig: {
            lang: string | undefined
            country?: string
            publicKey?: string
        }
    }
}

export default function TamaraWidget({ price }: { readonly price: Money }) {
    const ref = useRef<HTMLDivElement>(null)
    const [scriptLoaded, setScriptLoaded] = useState(false)
    const { locale, asPath } = useRouter()
    const config = useStoreConfig()
    const tamaraPublicKey = config?.base?.paymentWidgets?.tamara?.publicKey

    useEffect(() => {
        if (globalThis.window?.tamaraWidgetConfig !== undefined) {
            setScriptLoaded(true)
        }
    }, [])

    useEffect(() => {
        if (!ref.current || !scriptLoaded) return

        const container = ref.current
        container.innerHTML = ''

        globalThis.window.tamaraWidgetConfig = {
            lang: locale
        }
        container.innerHTML = `
            <tamara-widget
                type="tamara-summary"
                amount="${price.value || 0}"
                inline-type="0"
                config='{
                "publicKey":"${tamaraPublicKey}"
                }'
            >
              </tamara-widget>
            `
    }, [
        price.value,
        price.currency,
        locale,
        scriptLoaded,
        tamaraPublicKey,
        asPath
    ])

    return (
        <>
            <Script
                src="https://cdn.tamara.co/widget-v2/tamara-widget.js"
                strategy="afterInteractive"
                onLoad={() => setScriptLoaded(true)}
                key={`${asPath}-${price.value}`}
            />

            <div className={s['tamara-wrapper']}>
                {scriptLoaded && (
                    <div className={s['custom-ui']}>
                        <Tamara />
                    </div>
                )}

                <div ref={ref} className={s['tamara-promo-container']} />
            </div>
        </>
    )
}
